export const sectionData = [
    {
        id: 1,
        title: 'Акции и бонусы',
        text: 'Скидки на ТВ-приставки, роутеры, тарифы интернета, ТВ и другие услуги. Следите за новыми предложениями в разделе «Акции».',
        hrefText: 'Посмотреть акции и бонусы',
        href: '/promo',
        src: 'gifts.jpg',
        label: 'Акции круглый год',
    },
    {
        id: 2,
        title: 'Wi-Fi-точки на максимальной скорости',
        text: 'Дом.ру открыл 18 000 Wi-Fi-точек по всей России. Авторизуйтесь на Wi-Fi-портале как Клиент и получите интернет без ограничений по скорости.',
        hrefText: 'Найти ближайшие Wi-Fi-точки',
        href: '/internet/wifi',
        src: 'wi-fi-application.png',
        label: 'Городской Wi-Fi',
    },
    {
        id: 3,
        title: 'Телевидение всегда под рукой',
        text: 'Установите приложение на мобильное устройство, либо зайдите на сайт movix.ru и смотрите ТВ по дороге на работу или в любимом кафе. Всё что нужно — доступ в интернет.',
        hrefText: 'Узнать подробнее о сервисе',
        href: '/domru-tv/mobile',
        src: 'mobile-tv.png',
        label: 'Мобильное телевидение',
    },
];
